import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import UserInfo from '../../containers/UserInfo';
import Notifications from '../../containers/Notifications';
import Grid from '../Grid';
import SearchBar from '../../containers/SearchBar';
import * as constants from '../../containers/Authorization/constants';
import './styles.css';
import SearchToggleButton from '../SearchToggleButton';
import PageCaption from './page-caption';
import Image from '../Image';
import intersectImg from './intersect-by-powerschool.svg';
import HelpNavMenuWithProps from '../../containers/HelpNavMenu';
import { onHEAccountSubscription } from '../../utils/subscriptions';
import FeatureDisabled from '../FeatureDisabled';

const heAccountPredicate = (heAccount) => !heAccount.freemium &&
  heAccount.activeSubscriptions.some((each) => ![constants.HUBS_SUBSCRIPTION].includes(each));
export const SearchOnlyVisibleWhenAuthorized = onHEAccountSubscription(heAccountPredicate)(SearchBar);
export const SearchToggleButtonOnlyVisibleWhenAuthorized = onHEAccountSubscription(heAccountPredicate)(SearchToggleButton);

class SiteHeader extends React.PureComponent {
  static propTypes = {
    current: PropTypes.object.isRequired,
  };

  state = { showSearch: false };

  toggleSearch = () => {
    this.setState((prevState) => ({ showSearch: !prevState.showSearch }));
  };

  render() {
    const { current } = this.props;
    const { showSearch } = this.state;
    const isAuthenticated = get(current, 'viewer.isAuthenticated');
    return (
      <Grid>
        {isAuthenticated && (
        <Grid.Row styleName="print" verticalAlign="middle">
          <Grid.Column width={6}>
            <Image src={intersectImg} alt="" />
          </Grid.Column>
          <Grid.Column width={5}>
            <PageCaption className="hidden-mobile hidden-tablet" />
          </Grid.Column>
        </Grid.Row>
        )}
        {isAuthenticated && (
        <Grid.Row styleName="no-print" verticalAlign="middle">
          <Grid.Column computer={5} mobile={7} tablet={8} />
          <Grid.Column width={8} only="computer" textAlign="right">
            <SearchOnlyVisibleWhenAuthorized />
          </Grid.Column>
          <Grid.Column
            computer={3}
            mobile={9}
            tablet={8}
            textAlign="right"
            as="nav"
            styleName="align-right-icons"
          >
            <SearchToggleButtonOnlyVisibleWhenAuthorized
              className="hidden-computer"
              onClick={this.toggleSearch}
            />
            <HelpNavMenuWithProps />
            <FeatureDisabled anyOf={constants.DISABLE_LEGACY_COMMUNITY}>
              <Notifications />
            </FeatureDisabled>
            <UserInfo />
          </Grid.Column>
        </Grid.Row>
        )}
        {!isAuthenticated && (
        <Grid.Row centered>
          <Grid.Column computer={5} mobile={11} tablet={8}>
            <Image
              data-cy="login-intersect-logo"
              src="https://static.intersect.hobsons.com/svg/intersect-by-powerschool.svg"
              width="100%"
              height="100%"
              alt="Intersect by PowerSchool Logo"
            />
          </Grid.Column>
        </Grid.Row>
        )}
        {
          isAuthenticated && showSearch ? (
            <Grid.Row styleName="search-row-nav" only="tablet mobile">
              <Grid.Column styleName="search-row-nav-padding">
                <SearchOnlyVisibleWhenAuthorized searchBoxId="global-mobile-search-box" />
              </Grid.Column>
            </Grid.Row>
          ) : null
        }
      </Grid>
    );
  }
}
const mapStateToProps = (state) => ({
  current: state.current,
});

export default connect(mapStateToProps)(SiteHeader);
